import React from 'react';
import { Helmet } from 'react-helmet';
import { Users } from 'lucide-react';
import GlobalNavbar from '@/components/GlobalNavbar';
import Footer from '@/components/Footer';
import { useTranslation } from '@/hooks/useTranslation';

export default function AssistenteTecnicoPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#F8FAFB] flex flex-col font-sans">
      <Helmet>
        <title>Assistente Técnico - PROVATIO</title>
      </Helmet>
      <GlobalNavbar />
      <main className="flex-1 flex flex-col items-center justify-center p-6 text-center">
        <div className="max-w-2xl mx-auto bg-white p-12 rounded-xl shadow-sm border border-gray-100">
          <Users className="w-16 h-16 text-[#193D6D] mx-auto mb-6" />
          <h1 className="text-3xl font-bold text-[#193D6D] mb-4">Assistente Técnico</h1>
          <p className="text-gray-600 text-lg">
            Módulo dedicado à gestão e atuação de assistentes técnicos em processos judiciais e extrajudiciais.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}